import { Divider } from "@mui/material";

export const VerticalDivider = () => (
  <Divider
    orientation="vertical"
    variant="middle"
    flexItem
    sx={{ height: "32px", alignSelf: "center" }}
  />
);
